// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { Card } from '@/components';
import { CLASSES } from '@/constants/classes';
import ShippingAccountsList from './ShippingAccountsList';
import '@/style/pages/Preferences/ShippingAccounts.scss';

export default function PreferencesShippingAccountsPage() {
  return (
    <div
      className={classNames(
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT,
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT_SHIPPING_ACCOUNTS,
      )}
    >
      <ShippingAccountsCard>
        <ShippingAccountsList />
      </ShippingAccountsCard>
    </div>
  );
}

const ShippingAccountsCard = styled(Card)`
  padding: 0;
`;